import { render } from "./ContentWords.vue?vue&type=template&id=400db0b4&scoped=true"
import script from "./ContentWords.vue?vue&type=script&lang=js"
export * from "./ContentWords.vue?vue&type=script&lang=js"

import "./ContentWords.vue?vue&type=style&index=0&id=400db0b4&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400db0b4"]])

export default __exports__